export default __webpack_public_path__ + "static/media/Animals01.a25bbebe.jpg";